import React from 'react'
import '../../../Styles/Loader.scss'
const Ring = () => {
     return (
          <div className="lds-dual-ring h-9" />
     )
}

export default Ring